import e from "../managers/braze-instance.js";
import jt from "./utils/push-utils.js";
export function isPushPermissionGranted() {
  if (e.rr()) return jt.isPushPermissionGranted();
}
